import React from 'react';

import BnplFormContainer from './BnplFormContainer';

export default function AcceptInvite({ inviteRedirect }) {
  return (
    <BnplFormContainer showControls={false}>
      <div className="bnpl-form">
        <div className={`bnpl-form__title`}>
          Hello, click on the button below to accept the invitation. Accepting the invite will
          redirect you to the application
        </div>
        <div className={`bnpl-form__button-container`}>
          <button onClick={inviteRedirect}>Apply for Financing</button>
        </div>
      </div>
    </BnplFormContainer>
  );
}
